import { useQuery } from "@tanstack/react-query";
import smsPlaceHolderService from "..";

const useGetSmsPlaceHolder = () =>
  useQuery({
    queryKey: ["getSmsPlaceHolder"],
    queryFn: () => smsPlaceHolderService.getSmsPlaceHolders(),
    select: (res) => res,
  });

export { useGetSmsPlaceHolder };
